// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__oqT2E","container":"styles_container__3kHJb","title":"styles_title__2kgHn","wrapper":"styles_wrapper__31qJ2","answer":"styles_answer__6A1Q5"};